module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.$props.tagname, _vm._g({
    tag: "section",
    staticClass: "ps-container",
    on: {
      "~mouseover": function($event) {
        return _vm.update($event)
      }
    }
  }, _vm.$listeners), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44138184!./~/vue-loader/lib/selector.js?type=template&index=0!./index.vue
// module id = 8
// module chunks = 0